// 공개 사이트(Next)의 이용약관·개인정보처리방침 링크
const PAGE_CLIENT_URL = process.env.REACT_APP_PAGE_CLIENT_URL || 'https://shool.uk';
const LINK = 'font-semibold text-gray-800 underline underline-offset-2';

export function LegalLinks() {
    return (
        <>
            <a href={`${PAGE_CLIENT_URL}/terms`} target="_blank" rel="noreferrer" className={LINK}>이용약관</a>
            {' · '}
            <a href={`${PAGE_CLIENT_URL}/privacy`} target="_blank" rel="noreferrer" className={LINK}>개인정보처리방침</a>
        </>
    );
}
